/**
 * The secondary action — Referral, Bridge, Leaderboard, modal cancels.
 *
 * `.ce-btn-surface` is the raised-neutral recipe: `--raise` on `--pillow-sm`,
 * ink label. It is the default shape for anything that is present but not the
 * primary, and it is the one variant that reads correctly in both themes
 * without a second rule — `--raise` is a token.
 */
export const WhiteButton = ({ text, onClick = () => {}, className = "" }) => {
  return (
    <button type="button" onClick={onClick} className={`ce-btn ce-btn-surface ${className}`.trim()}>
      {text}
    </button>
  );
};
